<template lang="es">
    <div>
         <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" sm="12" md="6">
                       Asignación de Informadores municipales
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <v-btn
                            color=""
                            dark
                            class="mb-2 float-right bg-light-blue"
                            
                            @click="modalNuevo"
                        >
                            Asignar Informador
                        </v-btn>
                    </v-col> 
            
                </v-row>
                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>
                        
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="6" sm="6" xs="12">
                        <v-select
                            v-model="datosUsuario.departamentosId"
                            :items="deptos"
                            class="required"
                            dense
                            outlined
                            :loading="ddDeptosLoading"
                            label="Departamento"
                            item-text="nombreDepartamento"
                            item-value="id"
                            :rules="[
                                selectRequired(
                                    'rol'
                                )
                            ]"
                            @change="obtnenerMunicipiosPorDepto()"
                        ></v-select>
                    </v-col>

                    <v-col cols="12" md="6" sm="6" xs="12">
                        <v-select
                            v-model="datosUsuario.municipiosId"
                            :items="municipios"
                            class="required"
                            dense
                            outlined
                            :loading="ddMunicipiosLoading"
                            label="Municipio"
                            item-text="nombreMunicipio"
                            item-value="id"
                            
                        ></v-select>
                    </v-col>

                    <v-col cols="12" md="6" sm="6" xs="12" class="pt-1 pb-1">
                        <v-select
                            :items="periodos"
                            outlined
                            autocomplete="off"
                            class="required"
                            dense
                            item-text="anioMedicion"
                            item-value="id"
                            v-model="datosUsuario.periodoMedicionId"
                            label="Año de medición"
                            :rules="[
                                selectRequired(
                                    'Año de medición'
                                )
                            ]"
                            
                        ></v-select>
                    </v-col>

                    <v-col cols="12" md="6" sm="6" xs="12" class="pt-1 pb-1">
                        <v-btn
                            color=""
                            dark
                            class="mb-2 float-right bg-light-blue"
                            
                            @click="obtenerInformadoresAsignados()"
                        >
                            Buscar Informadores Asignados
                        </v-btn>
                    </v-col>
                </v-row>
                <v-data-table
                        :headers="headers"
                        :items="usuarios"
                        item-key="Id"
                        class="elevation-0"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                    
                        :items-per-page="10"
                        dense
                    >
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.id }}</td>
                            <td>{{ item.nombreUsuario }}</td>
                            <td>{{ item.correoUsuario }}</td>
                            <td>{{ item.nombreMunicipio }}</td>
                            <td>
                                <v-chip
                                    class="ma-2"
                                    :color="item.estadosId === 1 ? 'teal' : 'orange' "
                                    text-color="white"
                                    small
                                >
                                    {{item.estado}}
                                </v-chip>
                            </td>
                            <td>
                                <v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(item.id)">
                                    <v-icon left>mdi-pencil</v-icon> Actualizar
                                </v-btn>
                            </td>
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>
        <!-- Inicio:: Dialog para mostrar los datos de la etnia-->
    <v-dialog
        v-model="dialog"
        max-width="700px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                {{modalTitle}}
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                ref="form"
                v-on:submit.prevent="asignarInformador"
                v-model="validForm"
                >
                <v-card-text>
                    <v-row>

                        <v-col md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-autocomplete
                                v-model="datosAsignacion.usuariosId"
                                :items="informadores"
                                class="required"
                                dense
                                outlined
                                :loading="ddInformadoresLoading"
                                label="Seleccionar informador"
                                item-text="nombreUsuario"
                                item-value="id"
                                
                                :rules="[
                                    selectRequired(
                                        'informador'
                                    )
                                ]"
                            ></v-autocomplete>
                        </v-col>


                        <v-col  md="6" sm="6" xs="12" class="pt-1 pb-1">
                            
                            <v-select
                                :items="periodos"
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                item-text="anioMedicion"
                                item-value="id"
                                v-model="datosAsignacion.periodoMedicionId"
                                label="Año de medición"
                                :rules="[
                                    selectRequired(
                                        'Año de medición'
                                    )
                                ]"
                            ></v-select>
                        </v-col>

                       

                        
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6" xs="12">
                            <v-select
                                v-model="datosUsuario.departamentosId"
                                :items="deptos"
                                class="required"
                                dense
                                outlined
                                :loading="ddDeptosLoading"
                                label="Departamento"
                                item-text="nombreDepartamento"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'Departamento'
                                    )
                                ]"
                                @change="obtnenerMunicipiosPorDepto()"
                            ></v-select>
                        </v-col>

                        <v-col cols="12" md="6" xs="12">
                            <v-select
                                v-model="datosAsignacion.municipiosId"
                                :items="municipios"
                                class="required"
                                dense
                                outlined
                                :loading="ddMunicipiosLoading"
                                label="Municipio"
                                item-text="nombreMunicipio"
                                item-value="id"
                                :rules="[
                                    selectRequired(
                                        'Municipio'
                                    )
                                ]"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                            <v-btn
                                color="grey lighten-5"
                                elevation="0"
                                class="mb-2 float-right grey lighten-5"
                                @click="dialog = false; resetForm()"
                                :disabled="btnRegistroLoading"
                            >
                                Cancelar
                            </v-btn>
                            <!--:disabled="!validDocForm" type="submit"-->
                            <v-btn
                                color="primary"
                                class="mb-2 float-right"
                                type="submit"
                                :elevation="0" 
                                :disabled="!validForm" 
                                :loading="btnRegistroLoading"                         
                            >
                                {{btnRegistroText}}
                            </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>

    
    <!-- Fin:: Dialog para restablecer contraseña-->
    <!-- Fin:: Dialog para mostrar los datos de la etnia-->

    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>
<script>
import validations from "@/core/untils/validations.js";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { OBTENER_USUARIOS_INFORMADORES, OBTENER_USUARIOS_INFORMADORES_MUNI, OBTENER_ASIGNACION_USUARIO_INFORMADOR_MUNI, ASIGNAR_USUARIO_INFORMADOR, ACTUALIZAR_ASIGNACION_USUARIO_INFORMADOR } from "@/core/services/store/usuarios/usuarioinformador.module";
//import { OBTENER_REGIONES } from "@/core/services/store/region.module";
import { OBTENER_ROLES } from "@/core/services/store/rol.module";
import { OBTENER_PUESTOS } from "@/core/services/store/puesto.module";
import { OBTENER_DEPARTAMENTOS} from "@/core/services/store/catalogos/departamento.module";
import { OBTENER_MUNICIPIOS_POR_DEPTO } from "@/core/services/store/catalogos/municipio.module";

import { OBTENER_PERIODOS } from "@/core/services/store/catalogos/periodomedicion.module";

import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";
export default {
    name: "AdminInformadores",
    components: {
    SnackAlert,
    DialogLoader
    },
        data() {
        return {
            validForm:false,
            ddPuestosLoading:false,
            ddDeptosLoading:false,
            ddMunicipiosLoading:false,
            ddInformadoresLoading: false,
            itemName : "Usuarios Institucionales",
            dialog: false,
            accion:1,
            dialogResetPass:false,
            modalTitle: 'Registrar Usuario',
            btnRegistroLoading: false,
            btnResetPassLoading:false,
            dialogLoaderVisible: false,
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroText: 'Registrar Usuario',
            
            showPass:false,
            Pais_Id: 0,
            roles: [],
            puestos: [],
            deptos:[],
            periodos:[],
            departamentoId:0,
            municipios: [],
            usuarios: [],
            informadores:[],
            departamentos: [],
            switchItemEstado: true,
            nombreUsuario:'',
            idUsuario:0,
            datosUsuario: {
                id: 0,
                nombreUsuario: '',
                correoUsuario: '', 
                estadosId: 1,
                puestosId: 0,
                rolUsuarioId:4,
                institucionesId:null,
                municipiosId:0,
                pathDocumentoRespaldo: '',
            },
            datosAsignacion: {
                id:0,
                usuariosId: 0,
                periodoMedicionId:0,
                municipiosId:0,
                estadosId:0,
            },
            tableLoading: false,
            ...validations
        } 
    },
    methods: {
        modalNuevo(){
            this.accion =1;
            this.modalTitle='Asignar Informador';
            this.btnRegistroText='Asignar Informador';
            this.dialog=true;
        },

        resetForm(){
            //this.$refs.form.reset();
            this.datosUsuario={
                id: 0,
                nombreUsuario: '',
                correoUsuario: '', 
                estadosId: 1,
                puestosId: 0,
                rolUsuarioId:4,
                institucionesId:null,
                municipiosId:0,
                pathDocumentoRespaldo: '',
            };

            this.datosAsignacion= {
                usuariosId: 0,
                periodoMedicionId:0,
                municipiosId:0,
                estadosId:0,
            };

            this.switchItemEstado = true;
        },

        //!Obtener los roles para asignar al usuario
        async obtenerRoles(){
            this.roles=[];
            await this.$store
                .dispatch(OBTENER_ROLES)
                .then(res => {
                    if(res.status===200){
                    this.roles = this.$store.state.rol.roles;
                    }
                })
                .catch(err => {
                    console.log(err)
                });
            return;
        },

        //!Obtener los periodos para la tabla
        obtnenerPeriodosMedicion(){
           
            this.periodos=[];
            
            this.$store
                .dispatch(OBTENER_PERIODOS)
                .then(() => {
                    this.periodos = this.$store.state.periodomedicion.periodos;
                    
                })
                .catch(() => {
                   
                });

        },

        //!Obtener los roles para asignar al usuario
        async obtenerPuestos(){
            this.ddPuestosLoading =true;
            this.puestos=[];
            await this.$store
                .dispatch(OBTENER_PUESTOS, 1)
                .then(res => {
                    if(res.status==200){
                        this.puestos = this.$store.state.puesto.puestos;
                    }
                    this.ddPuestosLoading =false;
                //console.log(this.etnias)
                })
                .catch(err => {
                    this.ddPuestosLoading =false;
                    console.warn(err)
                });
        },

        //!Obtener los departamentos para la tabla
        obtnenerDepartamentos(){
            this.ddDeptosLoading = true;
            this.deptos=[];
            
            this.$store
                .dispatch(OBTENER_DEPARTAMENTOS,1)
                .then(res => {
                    if(res.status==200){
                        this.deptos = this.$store.state.departamento.departamentos;
                    }
                    this.ddDeptosLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.ddDeptosLoading = false;
                });

        },

        //!Obtener las etnias para la tabla
        async obtnenerMunicipiosPorDepto(){
           // console.log("dsfsdf")
            this.departamentoId = this.datosUsuario.departamentosId;
            this.ddMunicipiosLoading = true;
            this.municipios=[];
            
            await this.$store
                .dispatch(OBTENER_MUNICIPIOS_POR_DEPTO, {departamentoId: this.departamentoId, estadoId: 1})
                .then(res => {
                    if(res.status==200){
                        this.municipios = this.$store.state.municipio.municipios;
                    }
                    this.ddMunicipiosLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.ddMunicipiosLoading = false;
                });

        },

        //!Obtener los usuarios tipo informador para la asignacion
        async obtenerInformadores(){
            //this.tableLoading = true;
            this.informadores=[];
            await this.$store
                .dispatch(OBTENER_USUARIOS_INFORMADORES)
                .then(res => {
                    if(res.status===200){
                        this.informadores = this.$store.state.usuarioinformador.usuariosInformadores;
                    }
                    //this.tableLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    //this.tableLoading = false;
                });
        },

        //!Obtener los informadores asignados para la tabla
        async obtenerInformadoresAsignados(){
            this.tableLoading = true;
            this.usuarios=[];
            //console.log('22')
            await this.$store
                .dispatch(OBTENER_USUARIOS_INFORMADORES_MUNI, this.datosUsuario)
                .then(res => {
                    if(res.status===200){
                        this.usuarios = this.$store.state.usuarioinformador.usuariosInformadores;
                    }
                    this.tableLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.tableLoading = false;
                });

        },

        async asignarInformador(){
            this.switchItemEstado ? this.datosAsignacion.estadosId = 1 : this.datosAsignacion.estadosId = 2;
            this.btnRegistroLoading=true;

            if(this.accion===1){
                await this.$store.dispatch(ASIGNAR_USUARIO_INFORMADOR, this.datosAsignacion)
                .then(res=>{
                    if(res.status===200){
                        this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                        
                        this.datosUsuario.municipiosId = this.datosAsignacion.municipiosId;
                        this.resetForm();
                        this.dialog = false;
                        this.obtenerInformadoresAsignados();
                    } else {
                        this.$refs.snackalert.SnackbarShow('warning', 'Error', res.message);
                    }
                    this.btnRegistroLoading=false;
                })
                .catch(()=>{
                    this.$refs.snackalert.SnackbarShow('warning', 'Error', 'Ha ocurrido un error, por favor, ponte en contacto con un administrador del sistema.');
                    this.btnRegistroLoading=false;
                })
            } else {
                await this.$store.dispatch(ACTUALIZAR_ASIGNACION_USUARIO_INFORMADOR, this.datosAsignacion)
                .then(res=>{
                    if(res.status===200){
                        this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                        
                        this.datosUsuario.municipiosId = this.datosAsignacion.municipiosId;
                        this.resetForm();
                        this.dialog = false;
                        this.obtenerInformadoresAsignados();
                    } else {
                        this.$refs.snackalert.SnackbarShow('warning', 'Error', res.message);
                    }
                    this.btnRegistroLoading=false;
                })
                .catch(()=>{
                    this.$refs.snackalert.SnackbarShow('warning', 'Error', 'Ha ocurrido un error, por favor, ponte en contacto con un administrador del sistema.');
                    this.btnRegistroLoading=false;
                })
            }
        },

        obtenerDatosItem(Id){
            this.dialogLoaderVisible=true;
            this.datosUsuario.id = Id;
            this.accion=2;
            this.modalTitle='Actualizar Asignación';
            this.btnRegistroText='Actualizar Asignación';

            this.$store
                .dispatch(OBTENER_ASIGNACION_USUARIO_INFORMADOR_MUNI, Id)
                .then(res => {
                    console.log(res)
                    if(res.status===200){
                    this.datosAsignacion = this.$store.state.usuarioinformador.asignacionInformador;
                    this.datosAsignacion.estadosId === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                   // this.datosUsuario.Contrasenia = 'Segeplan@2021';
                        //this.obtenerDepartamentos().then(()=>{
                    this.dialog = true;
                            
                    } else{
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                    }
                    this.dialogLoaderVisible = false;
                    //});
                })
                .catch(error => {
                    this.dialogLoaderVisible = false;
                    console.log(error)
                });
        },
        
       
        

       /**
       * Modal de confirmacion de cambio de contraseña
       */
        mostrarModalResetPass(nombreUsuario, id){
            this.dialogResetPass=true;
            this.nombreUsuario = nombreUsuario;
            this.idUsuario = id;
        },
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "/dashboard" },
            { title: "Informadores Municipales" },
            { title: "Asignación" },
        ]);
    },

    created(){
        //this.obtenerItems();
        this.obtenerRoles();
        this.obtenerPuestos();
        this.obtnenerDepartamentos();
        this.obtenerInformadores();
        this.obtnenerPeriodosMedicion();
    },

    computed: {
        headers() {
            return [
                {
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },
                {
                    text: "Nombre del usuario",
                    value: "nombreUsuario"
                },
                {
                    text: "Correo",
                    value: "correoUsuario"
                },
                {
                    text: "Municipalidad",
                    value: "municipalidad"
                },
                {
                    text: "Estado",
                    value: "estadosId"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        }
    }
}
</script>
<style lang="">
    
</style>